import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector as useUntypedSelector } from 'react-redux';
import { Action } from 'redux';
import { StoreState } from './store/types';

export function useForceUpdate() {
  const [ , setState ] = useState(0);
  return useCallback(() => setState(s => s + 1), []);
}

export function useAction<A extends any[]>(actionCreator: (...args: A) => Action) {
  const dispatch = useDispatch()
  return useCallback((...args: A) => dispatch(actionCreator(...args)), [ actionCreator, dispatch ])
}

export function useSelector<TSelected>(selector: (state: StoreState) => TSelected, equalityFn?: (a: TSelected, b: TSelected) => boolean): TSelected {
  return useUntypedSelector<StoreState, TSelected>(selector, equalityFn)
}

type Callback = () => void;

export function useInterval(callback: Callback, delay: number | null, additionalDependencies: any[] = []) {
   const savedCallback = useRef<Callback>();

   // Remember the latest callback.
   useEffect(() => {
      savedCallback.current = callback;
   }, [ callback ]);

   // Set up the interval.
   useEffect(() => {
      function tick() {
         savedCallback.current!();
      }

      if (delay !== null) {
         const id = setInterval(tick, delay);
         return () => clearInterval(id);
      }

      return;
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [ delay, ...additionalDependencies ]);
}
